import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'clearing-vendor',
        label: 'Vendors',
        to: '/clearing/vendor',
      }),
    }) satisfies AggregateBreadcrumb,
});
